<template>
    <modal :show="show" v-if="isValid('Day Start')">

        <div style="margin-bottom:0px" class="card">
            <div class="card-body">
                <div class="col-lg-12">
                    <div class="tab-content" id="nav-tabContent">
                        <div class="modal-header">
                            <h5 class="modal-title" id="myModalLabel"> {{ $t('TransferCounter') }}</h5> {{dayStart.fromTime}}
                        </div>
                        <div class="card-body">
                            <div class="row " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                                <h6 class="text-center">  {{UserName}}</h6>

                                <div class="form-group has-label col-sm-12 " v-bind:class="{ 'has-danger': $v.dayStart.date.$error}">
                                    <label class="text  font-weight-bolder">   {{ $t('Date') }}:<span class="LabelColour"> *</span> </label>
                                    <datepicker v-model="$v.dayStart.date.$model" :key="dateRander" :datedisable="true" :isDisable="true" />
                                    <span v-if="$v.dayStart.date.$error" class="error text-danger">
                                        <span v-if="!$v.dayStart.date.required">  {{ $t('DateRequired') }}</span>
                                    </span>
                                </div>

                                <div class="form-group has-label col-sm-6" v-bind:class="{ 'has-danger': $v.dayStart.fromTime.$error}">
                                    <label class="text  font-weight-bolder">{{ $t('FromTime') }}:<span class="LabelColour"> *</span></label>
                                    <vue-timepicker disabled v-model="$v.dayStart.fromTime.$model" :key="time" input-width="100%"></vue-timepicker>
                                    <span v-if="$v.dayStart.fromTime.$error" class="error text-danger">
                                        <span v-if="!$v.dayStart.fromTime.required">{{ $t('TimeRequired') }}</span>
                                    </span>
                                </div>
                                <!--<div class="form-group has-label col-sm-6" v-if="type=='Edit'">
                                <label class="text  font-weight-bolder">To Time:*</label>
                                <vue-timepicker v-model="dayStart.toTime" :key="time" input-width="100%"></vue-timepicker>
                            </div>-->

                                <div class="form-group has-label col-sm-6 ">
                                    <label class="text  font-weight-bolder"> {{ $t('Counter') }}:<span class="LabelColour"> *</span></label>
                                    <terminal-dropdown :isDisable="true" :terminalType="terminalType" :isSelect="true" v-model="dayStart.counterId" :key="render" v-on:input="getOpeningBalance" :values="dayStart.counterId" :isDayStart=true />

                                </div>

                                <div class="form-group has-label col-sm-6 ">
                                    <label class="text  font-weight-bolder"> {{ $t('OpeningCash') }}:* </label>
                                    <input class="form-control" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" v-model="dayStart.openingCash" type="number" disabled />
                                </div>
                                <div class="form-group has-label col-sm-6 ">
                                    <label class="text  font-weight-bolder"> {{ $t('DayStarts.CashInHand') }}: </label>
                                    <input class="form-control" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" v-model="dayStart.cashInHand" type="number" disabled @click="$event.target.select()" />
                                </div>
                                <div class="form-group has-label col-sm-6 ">
                                    <label class="text  font-weight-bolder"> {{ $t('DayStarts.Bank') }}: ({{$t('Transactions')}} : {{transactions}})</label>
                                    <input class="form-control" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" v-model="dayStart.bankAmount" type="number" disabled @click="$event.target.select()" />
                                </div>
                                <div class="form-group has-label col-sm-6 ">
                                    <label class="text  font-weight-bolder"> {{ $t('DayStarts.Expense') }}: </label>
                                    <input class="form-control" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" v-model="dayStart.expenseCash" type="number" disabled @click="$event.target.select()" />
                                </div>
                                <div class="form-group has-label col-sm-6 ">
                                    <label class="text  font-weight-bolder"> {{ $t('DayStarts.Total') }} </label>
                                    <input class="form-control" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" :value="total | roundAmount" type="number" disabled @click="$event.target.select()" />
                                </div>
                                <div class="form-group has-label col-sm-6 " v-bind:class="{ 'has-danger': $v.dayStart.verifyCash.$error}">
                                    <label class="text  font-weight-bolder">  {{ $t('VerifyCash') }}:<span class="LabelColour"> *</span> </label>
                                    <input class="form-control" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" v-model="$v.dayStart.verifyCash.$model" type="number" @click="$event.target.select()" />
                                    <span v-if="$v.dayStart.verifyCash.$error" class="error text-danger">
                                        <span v-if="!$v.dayStart.verifyCash.required">{{ $t('VerifyCashRequired') }}</span>
                                    </span>
                                </div>


                                <div class="form-group has-label col-sm-6 ">
                                    <label class="text  font-weight-bolder"> {{ $t('TransferFromUser') }}:<span class="LabelColour"> *</span> </label>
                                    <input class="form-control" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" v-model="$v.dayStart.user.$model" type="text" />
                                </div>
                                <div class="form-group has-label col-sm-6 ">
                                    <label class="text  font-weight-bolder"> {{ $t('TransferFromPassword') }}:<span class="LabelColour"> *</span> </label>
                                    <input class="form-control" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" v-model="$v.dayStart.password.$model" type="password" />
                                </div>
                                <div class="form-group has-label col-sm-6 ">

                                    <label class="text  font-weight-bolder"> {{ $t('TransferToUser') }}:<span class="LabelColour"> *</span> </label>
                                    <usersDropdown :isTransfer="true" v-model="$v.dayStart.toUser.$model"></usersDropdown>
                                </div>
                                <div class="form-group has-label col-sm-6 ">
                                    <label class="text  font-weight-bolder"> {{ $t('TransferToPassword') }}:<span class="LabelColour"> *</span> </label>
                                    <input class="form-control" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" v-model="$v.dayStart.toPassword.$model" type="password" />
                                </div>

                            </div>
                        </div>

                        <div class="modal-footer justify-content-right" v-if="type=='Edit'&& isValid('Day Start')">

                            <button type="button" class="btn btn-primary  " v-on:click="SaveDayStart"><i class="far fa-save"></i> {{ $t('DayClose') }}</button>
                            <button type="button" class="btn btn-danger  mr-3 " v-on:click="close()">{{ $t('Cancel') }}</button>

                        </div>
                        <div class="modal-footer justify-content-right" v-else>

                            <button type="button" class="btn btn-success  " v-on:click="SaveDayStart" :disabled="$v.dayStart.$invalid "><i class="far fa-save"></i> {{ $t('Start') }}</button>
                            <button type="button" class="btn btn-danger  mr-3 " v-on:click="close()"> {{ $t('Cancel') }}</button>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <dayEndReportPrint :headerFooter="headerFooter" :printDetail="printDetail" :isTransfer="isTransferPrint" v-if="printReport" v-bind:key="printRender"></dayEndReportPrint>
        <dayEndA4ReportPrint :headerFooter="headerFooter" :isTransfer="isTransferPrint" :printDetail="printDetail" v-if="printA4Report" v-bind:key="printRender"></dayEndA4ReportPrint>
    </modal>
    <acessdenied v-else :model=true></acessdenied>
</template>
<script>
    import clickMixin from '@/Mixins/clickMixin'
    import 'vue-loading-overlay/dist/vue-loading.css';
    import VueTimepicker from 'vue2-timepicker'
    import moment from "moment";
    import 'vue2-timepicker/dist/VueTimepicker.css'

    import { required } from "vuelidate/lib/validators"
    export default {
        mixins: [clickMixin],
        components: {

            VueTimepicker
        },
        props: ['show', 'counterCode', 'openingCash', 'type', 'counterId','isExpenseDay','isFirstUser'],
        data: function () {
            return {
                printReport: false,
                printA4Report: false,
                InvoiceSetting: '',
                render: 0,
                time: 0,
                dateRander: 0,
                UserName: '',
                CompanyID: '',
                UserID: '',
                isOpenDay: '',
                transactions: 0,
                startTime: '',
                grandTotal: 0,
                isSupervisor: false,
                isTransferPrint: true,
                total: 0,
                terminalType: 'CashCounter',
                dayStart: {
                    id: '00000000-0000-0000-0000-000000000000',
                    date: '',
                    fromTime: '',
                    toTime: '',
                    isActive: true,
                    counterCode: '',
                    locationId: '',
                    openingCash: 0,
                    verifyCash: null,
                    user: '',
                    password: '',
                    toUser: '',
                    toPassword: '',
                    counterId: '00000000-0000-0000-0000-000000000000',
                    isExpenseDay: false,
                    isFirstUser: false,
                    isTransfer: true,
                    expenseCash: 0,
                    bankAmount: 0,
                    cashInHand:0,
                },
                headerFooter: {
                    footerEn: '',
                    footerAr: '',
                    company: ''
                },
                printRender: 0,
                printRenderA4:0
            }
        },
        validations: {
            dayStart: {
                date: {
                    required
                },
                fromTime: {
                    required,
                    isValid: function (value) {
                        if (value.includes('mm') || value.includes('HH')) {
                            return false
                        }
                        return true;
                    }
                },
                verifyCash: {
                    required
                },
                user: {
                    required
                },

                password: {
                    required
                },
                toUser: {
                    required
                },

                toPassword: {
                    required
                }
            }
        },
        methods: {
            
            GetHeaderDetail: function () {

                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get("/Company/GetCompanyDetail?id=" + localStorage.getItem('CompanyID'), { headers: { Authorization: `Bearer ${token}` }, })
                    .then(function (response) {
                        if (response.data != null) {
                            root.headerFooter.company = response.data;

                        }
                    });
            },
            PrintDayTransfer: function () {

                this.GetHeaderDetail();
                this.printRender++;
                if (this.InvoiceSetting == 'A4') {
                    this.printA4Report = true;
                    //this.logout();
                }
                else {
                    this.printReport = true;

                }

            },
            getOpeningBalance: function (id) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                
                this.dayStart.counterId = id;
                this.$https.get('/Product/OpeningBalance?counterId=' + this.dayStart.counterId + '&isOpeningCash=' + false, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    
                    if (response.data != null) {
                        
                        root.dayStart.openingCash = response.data.openingBalance < 0 ? response.data.openingBalance * (-1) : response.data.openingBalance

                        var cashInHand = parseFloat(parseFloat(response.data.cashInHand) - parseFloat(response.data.openingBalance) - parseFloat(response.data.draftExpense)).toFixed(3).slice(0, -1)
                        root.dayStart.cashInHand = cashInHand < 0 ? cashInHand.toFixed(3).slice(0, -1) * (-1) : parseFloat(cashInHand).toFixed(3).slice(0, -1)
                        root.dayStart.bankAmount = parseFloat(response.data.bank).toFixed(3).slice(0, -1)
                        root.dayStart.expenseCash = parseFloat(parseFloat(response.data.draftExpense) + parseFloat(response.data.postExpense)).toFixed(3).slice(0, -1)
                        var total = parseFloat(parseFloat(response.data.cashInHand) - parseFloat(response.data.draftExpense)).toFixed(3).slice(0, -1)
                        root.transactions = response.data.noOfTransaction
                        root.total = total < 0 ? total * (-1) : total;
                    }
                });
            },
            getTerminalByUserId: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                this.$https.get('/Product/GetTerminalByUserId', { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {

                    if (response.data) {
                        
                        root.dayStart.counterId = response.data
                        root.render++;
                    }

                });
            },
            close: function () {
                this.$emit('close');
            },
            
            SaveDayStart: function () {
                
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                this.dayStart.isFirstUser = this.isFirstUser;
                
                if (this.dayStart.id == '00000000-0000-0000-0000-000000000000' || this.dayStart.id == undefined || this.dayStart.id == '') {
                    this.dayStart.saleId = this.UserID;
                    this.dayStart.locationId = this.CompanyID;
                }
                
                this.printDetail = this.dayStart;
                this.printDetail.grandTotal = this.dayStart.cashInHand;
                this.printDetail.total = this.total;
                this.printDetail.startTime = this.dayStart.fromTime;
                this.printDetail.toTime = moment().format("HH:mm ");
                this.printDetail.startDate = this.dayStart.date;
                this.printDetail.totalCash = parseFloat(this.dayStart.cashInHand) + parseFloat(this.dayStart.openingCash) + parseFloat(this.dayStart.expenseCash);
                this.printDetail.getTotalSale = parseFloat(this.dayStart.cashInHand) + parseFloat(this.dayStart.expenseCash);
                this.printDetail.bankDetails = this.bankDetails;
                this.printDetail.transactions = this.transactions;
                this.printDetail.counterCode = this.counterCode;
                this.$https.post('/Product/SaveDayStart?isDayStart=' + true, this.dayStart, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {

                    if (response.data != null) {
                        
                        root.$swal({
                            title: root.$t('SavedSuccessfully'),
                            text: root.$t('Saved'),
                            type: 'success',
                            icon: 'success',
                            showConfirmButton: false,
                            timer: 1500,
                            timerProgressBar: true,
                        });
                        //localStorage.setItem('token', response.data.result.token);
                        //var time = moment().format('h:mm a');
                        //localStorage.setItem('CounterCode', root.dayStart.counterCode);
                        //localStorage.setItem('DayStartTime', time);
                        //localStorage.setItem('IsDayStart', true);
                        //root.close();
                        //localStorage.setItem('IsExpenseDay', response.data.result.isExpenseDay);
                        root.PrintDayTransfer();
                        
                      

                      /*  root.$router.go('/daystart')*/
                         
                    }
                    else {
                        
                        root.$swal({
                            title: root.$t('Error'),
                            text: root.$t('DayStartAlreadyExist'),
                            type: 'error',
                            icon: 'success',
                            showConfirmButton: false,
                            timer: 800,
                            timerProgressBar: true,
                        });
                    }
                }).catch(error => {
                    
                    console.log(error)
                    root.$swal.fire(
                        {
                            icon: 'error',
                            title: 'Error!',
                            text: error.response.data,

                            showConfirmButton: false,
                            timer: 5000,
                            timerProgressBar: true,
                        });

                    root.loading = false
                })
            }
        },
        mounted: function () {
            
            if (this.dayStart.id == '00000000-0000-0000-0000-000000000000' || this.dayStart.id == undefined || this.dayStart.id == '') {
                this.dayStart.fromTime = moment().format('HH:mm');
                this.dayStart.date = moment().format('llll');
                this.dateRander++;
                this.time++;
                if (this.$session.exists()) {
                    this.UserName = localStorage.getItem('UserName');
                    this.CompanyID = localStorage.getItem('CompanyID');
                    this.UserID = localStorage.getItem('UserID');
                    this.isOpenDay = localStorage.getItem('IsOpenDay') == 'true' ? true : false;
                    this.InvoiceSetting = localStorage.getItem('PrintSizeA4');
                }
                this.dayStart.isOpenDay = this.isOpenDay;
                this.dayStart.counterCode = this.counterCode;
                this.dayStart.openingCash = this.openingCash;
                this.dayStart.counterId = this.counterId;
                this.dayStart.isExpenseDay = this.isExpenseDay;
                this.getTerminalByUserId();

            }
        }
    }
</script>
